import "./OurRoots.module.css";
import Header from "@/reusable_sections/Header";
import TheEcoGrowStory from "./sections/TheEcoGrowStory";
import OurGrowthTimeline from "./sections/OurGrowthTimeline";
import Footer from "@/reusable_sections/Footer";
export default function OurRootsPage() {
  return <div>
      <Header />
      <TheEcoGrowStory />
      <OurGrowthTimeline />
      <Footer />
    </div>;
}